import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
// Below is for import the icons
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import Loading from "../Student/Reusablecomponents/Loading";
import InternetChecking from "../Student/Reusablecomponents/Network";
import CopyRight from "../Student/Reusablecomponents/Copyright";
import ScenarioQuestionformat from "../Student/Reusablecomponents/ScenarioQuestionformat";
import { AssessmentName } from "../Student/Reusablecomponents/RegularFunctions";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Grade } from "../Student/Reusablecomponents/RegularFunctions";
import NSFLOgo from "../Student/Assests/Images/NSFLOgo.jpg";
import NCLLOgo from "../Student/Assests/Images/NCLogo.png";
import { Languages, NCAssessmentName } from "../ReusableComponents/CommonFunctions";
import { SelectLanguageData } from "../Redux/Reducers/Common/Language";
import axiosInstance from "../ReusableComponents/Axios";
const OMRQuestionPaper = () => {
  // const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const QuestionPaperRef = useRef();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector((state) => state.SelectLanguageData.SLanguage);
     const USYear = useSelector((state) => state.SelecYearData.SYear);
  const [ViewSheet, SetViewSheet] = useState({});
  const [GetGrade, SetGetGrade] = useState();
  const [Load, SetLoad] = useState(false);
  const [PaperSet, SetPaperSet] = useState(1);
  const [PaperSetOptions] = useState([1, 2, 3, 4]);
  const paperCodeValue =
    location?.state?.instituteId === 5 &&
      location?.state?.paperSets === "multiple"
      ? PaperSet
      : 0;
  const GetQuestionSheet = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/School/GetQuestionSheet?ContestCreationId=${location.state?.CCID
        }&SchoolId=0&Class=${GetGrade || location.state?.Grade}&UserId=${location.state?.UserId || 0}&PaperCode=${paperCodeValue || 0}&LanguageId=${location.state?.LanguID || SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          if (items.userTypeId === 4) {
            const order = res.data.filter((Sub) => location.state.Subjects.split(",").map((s) => s.trim()).includes(Sub.subjectName))
              .reduce((acc, item) => {
                (acc[item.subjectName] = acc[item.subjectName] || []).push(item);
                return acc;
              }, {});
            SetViewSheet(order);
          } else {
            const order = res.data.reduce((acc, item) => {
              (acc[item.subjectName] = acc[item.subjectName] || []).push(item);
              return acc;
            }, {});
            SetViewSheet(order);
          }
        } else {
          SetViewSheet({
            Message: "Please generate questions for selected grade",
          });
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        SetViewSheet({
          Message: "Please generate questions for selected grade",
        });
      });
  };

  useEffect(() => {
    if (GetGrade || location.state?.Grade) {
      if (location.state?.AType === 1) {
        GetQuestionSheet();
      } else if (location.state?.AType === 2) {
        GetSadhanaQuestionSheet();
      } else if (location.state?.AType === 3) {
        GetSamagraQuestionSheet();
      }
    }
  }, [GetGrade, paperCodeValue, SelectLanguage]);

  const GetSadhanaQuestionSheet = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/School/GetSadhanaQuestionSheet?ContestCreationId=${location.state?.CCID
        }&SchoolId=0&Class=${GetGrade || location.state?.Grade}&UserId=${location.state?.UserId || 0}&PaperCode=${paperCodeValue || 0}&LanguageId=${location.state?.LanguID || SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          if (items.userTypeId === 4) {
            const order = res.data.filter((Sub) => location.state.Subjects.split(",").map((s) => s.trim()).includes(Sub.subjectName))
              .reduce((acc, item) => {
                (acc[item.subjectName] = acc[item.subjectName] || []).push(item);
                return acc;
              }, {});
            SetViewSheet(order);
          } else {
            const order = res.data.reduce((acc, item) => {
              (acc[item.subjectName] = acc[item.subjectName] || []).push(item);
              return acc;
            }, {});
            SetViewSheet(order);
          }
        } else {
          SetViewSheet({
            Message: "Please generate questions for selected grade",
          });
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        SetViewSheet({
          Message: "Please generate questions for selected grade",
        });
      });
  };
  const GetSamagraQuestionSheet = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/School/GetSamagraQuestionSheet?ContestCreationId=${location.state?.CCID
        }&SchoolId=0&Class=${GetGrade || location.state?.Grade}&LanguageId=${location.state?.LanguID || SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          if (items.userTypeId === 4) {
            const order = res.data.filter((Sub) => location.state.Subjects.split(",").map((s) => s.trim()).includes(Sub.subjectName))
              .reduce((acc, item) => {
                (acc[item.subjectName] = acc[item.subjectName] || []).push(item);
                return acc;
              }, {});
            SetViewSheet(order);
          } else {
            const order = res.data.reduce((acc, item) => {
              (acc[item.subjectName] = acc[item.subjectName] || []).push(item);
              return acc;
            }, {});
            SetViewSheet(order);
          }
        } else {
          SetViewSheet({
            Message: "Please generate questions for selected grade",
          });
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        SetViewSheet({
          Message: "Please generate questions for selected grade",
        });
      });
  };

  const DownloadPDF = async () => {
    try {
      const payload = {
        userTypeId: items?.userTypeId || 0,
        userId: items?.userId || 0,
        reportType: "Question Paper",
        contestCreationId: location.state?.CCID || 0,
        assessmentTypeId: location.state?.AType || 0
      };
      await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);

    } catch (error) {
      console.error("Error logging report download:", error);
    }
    const printContents = QuestionPaperRef.current.innerHTML;
    const printWindow = window.open("", "", "height=800,width=600");
    const filename = `NCP_QuestionPaper_${NCAssessmentName(
      location.state.AType)}_${location?.state?.date}`;
    printWindow.document.write(`
    <html>
      <head>
        <style>
          /* General styles for print */
          @media print {
            body {
            font-size: 25px;
              position: relative;
              
            }

            /* Watermark style */
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 100px;
              color: rgba(0, 0, 0, 0.06); /* low opacity z-index: 9999;*/
              pointer-events: none;          
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: space-between; /* logos left/right */
  align-items: center;
  white-space: nowrap;
  gap: 50px;
}

.Icons-Div div {
  flex: 1; /* take remaining space */
  text-align: center; /* center text */
}
.Icons-Div img {
              width: 30%;
              // height: 60px;
            }
            .Options  {
              display: flex !important; 
              align-items: center;
              gap: 8px;
              line-height: 1.4;
              page-break-inside: avoid;
              margin: 4px 0;
            }
              .Sub-Details{ display: flex !important; 
                justify-content: space-between;
              }
.Each-Question{
 margin-bottom: 40px;
}
            .Options > span  {
              display: inline-flex !important;
              align-items: center;
              white-space: nowrap !important;
            }
              .Options p{
              margin: 0px !important;}
.alignitems{
  display: inline-flex !important;
              align-items: center;
              white-space: nowrap !important;
}
      .PDFhide{
      display:none;}
      .Question div p{
      margin: 0mm !important;;
      }
         .QNo{
    display: flex !important;
    flex-direction:row !important;}
         /*white-space: nowrap !important;}
            Ensure watermark appears on every page */
            @page {
              size: A4;
              margin: 10mm;
            }
          }
        </style>
      </head>
      <body>
     

  <div style="border-bottom:1px solid #000;padding:15px;text-align:center;">
        <img src="${NSFLOgo}" alt="NSF Logo"/>
    </div>

<div style="display:flex;padding:20px;justify-content:space-between;align-items:center;">

        <!-- Time -->
        <div style="width:180px;height:90px;border:1px solid #000;display:flex;">
            <div style="width:50%;border-right:1px solid #000;display:flex;justify-content:center;align-items:center;font-size:18px;font-weight:bold;">
                Time:
            </div>

            <div style="width:50%;"></div>
        </div>

        <!-- Title -->
        <div style="flex:1;text-align:center;padding:0 20px;">

            <h2 style="margin:5px 0;">
                ${items?.schoolName}
            </h2>

            <h3 style="margin:5px 0;">
                ${location.state?.ATName} Assessment
            </h3>

            <h2 style="margin:5px 0;">
                Grade ${location.state?.Grade || GetGrade} – Academic Year: ${USYear?.display}
            </h2>

        </div>
        <div style="width:140px;height:70px;border:1px solid #000;display:flex;">

    <!-- Left Side -->
    <div style="
        width:50%;
        border-right:1px solid #000;
        display:flex;
        justify-content:center;
        align-items:center;
        font-weight:bold;
        font-size:18px;">
        Marks:
    </div>

    <!-- Right Side -->
    <div style="
        width:50%;
        display:flex;
        flex-direction:column;">

        <!-- Top Empty Box -->
        <div style="
            flex:1;
            border-bottom:1px solid #000;">
        </div>

        <!-- Bottom Number -->
        <div style="
            flex:1;
            display:flex;
            justify-content:center;
            align-items:center;
            font-size:30px;
            font-weight:bold;">
            ${(location.state?.Grade || GetGrade) < 11 ? Object.entries(ViewSheet).length * ViewSheet[Object.keys(ViewSheet)[0]][0].totalCredits : ""}
        </div>
    </div>
</div>

    </div>

     <div style="padding:12px 25px;font-size:20px;">
        <b>Name:</b>............................................................................................
        :
        ....................................
    </div>

    <div style="padding:12px 25px;font-size:20px;">
        <b>School:</b>.................................................................................................................................
    </div>

    

   
 <div style="border-top:1px solid #000;padding:15px;">
    </div>
        <div class="watermark">NORTH SOUTH FOUNDATION</div>
      ${printContents}
      <script>
          window.onload = function() {
            setTimeout(() => {
              document.title = "${filename}";
              window.print();
              window.close();
            }, 400);
          }
        <\/script>
      </body>
    </html>
  `);
    printWindow.document.close();
  };
  //  <div style="display:flex;justify-content:space-between;padding:15px 25px;font-size:18px;font-weight:bold;">
  //         <div>Time: ${location?.state?.Duration} Minutes</div>
  //         <div>Marks:  ${(location.state?.Grade || GetGrade) < 11 ? Object.entries(ViewSheet).length * ViewSheet[Object.keys(ViewSheet)[0]][0].totalCredits : "...."} (2 mark each)</div>
  //     </div>
  return (
    <>
      <div className="TeacherBgImage ">
        <InternetChecking />
        <div className="MainHeading">
          {AssessmentName(location.state?.AType)} - Question Paper
        </div>

        <div className="dflex JSBetween mt-1">
          <div></div>
          <div className="dflex gap-3 alignitems">
            {items.userTypeId !== 4 && (
              <Grade className="NCLDropdown" PostGrade={SetGetGrade} />
            )}
            {location?.state?.instituteId === 5 &&
              location?.state?.paperSets === "multiple" && (
                <select
                  className="NCLDropdown"
                  value={PaperSet}
                  onChange={(e) => SetPaperSet(Number(e.target.value))}
                >
                  {PaperSetOptions.map((set) => (
                    <option key={set} value={set}>
                      Paper Set {set}
                    </option>
                  ))}
                </select>
              )}
            {Object?.keys(ViewSheet)?.length > 1 ?
              <button className="Buttons" onClick={DownloadPDF}>
                Download Question Paper
              </button> : ""}
            {location?.state?.QHindi ? <>
              <div className="DropdownHeader">Medium:
                <Languages onChange={(e) => { dispatch(SelectLanguageData({ SLanguage: parseInt(e) })); }}
                /></div></> : ""}
          </div>

        </div>

        <div className="Deatils-VASheet mt-2" ref={QuestionPaperRef}>
          {Object?.keys(ViewSheet)?.length > 1 ? (
            Object.keys(ViewSheet)?.map((order) => (
              <div key={order} className="QuestionSet">
                <div className="Sub-Details dflex JSBetween mt-4">
                  <h5>
                    <b>Subject :</b> {order}
                  </h5>
                  <h6>
                    <b>No.of Questions :</b> {ViewSheet[order][0].noOfQuestions}
                  </h6>
                  {/* <h6>
                    <b>Total Credits :</b> {ViewSheet[order][0].totalCredits}
                  </h6> */}
                </div>
                {ViewSheet[order]?.map((item, index) => (
                  <div className="Each-Question dflex flexd-column">
                    {item.scenario && (
                      <div
                        className="VScenario dflex flexd-column"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <div>
                          {" "}
                          <b>Scenario :</b>{" "}
                          <ScenarioQuestionformat scenario={item.scenario} />
                        </div>
                      </div>
                    )}

                    <div className="RQuestion dflex">
                      <div className="Question dflex ">
                        <div className="QNo">
                          <b>{index + 1}.</b>
                          <ScenarioQuestionformat scenario={item.questions} />
                        </div>
                      </div>
                    </div>
                    {item.questionType === "M" &&
                      ["A", "B", "C", "D"].map((option, i) => (
                        item[`option${option}`] &&
                        <div
                          key={i}
                          className="Options" >
                          {option})
                          <span>
                            <ScenarioQuestionformat
                              scenario={item[`option${option}`]}
                            />
                          </span>
                        </div>
                      ))}

                    {/* <div className="alignitems">
                      <b>Answer :</b>
                      <div>
                        <ScenarioQuestionformat scenario={item?.answer} />{" "}
                      </div>
                    </div> */}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <div
              className="dflex JCCenter"
              style={{ fontSize: "20px", margin: "2rem 0rem" }}
            >
              {" "}
              {ViewSheet?.Message}
            </div>
          )}
        </div>
        {items.userTypeId !== 2 && <CopyRight />}
      </div>

      {Load && <Loading />}
    </>
  );
};
export default OMRQuestionPaper;
